// bootSplash.js — the instant splash in index.html, and who may take it down.
//
// v0.84.0 — main.jsx retired it after React's first paint.
// v0.286.0 — A CLIENT'S REPORT WAITS BEHIND IT. Brett: "when the client droppin
// report first opens it splashes the report then it disapears. Can we stop this
// so its a waiting screen until it is ready to display." On a /r/<token> page
// index.html's head marks the page (html.boot-report) before the splash exists,
// so it is held and worded for the reader ("Opening your report") from the
// first paint; the report screen takes it down once the report — or
// the reason there is none — is on screen. Two ceilings so a held splash can
// never cover the page for good: nobody claimed it (the route did not match),
// or nothing answered at all.

const CLAIM_MS = 4000;
const CEILING_MS = 120000;

let retired = false;
let claimed = false;

function splash() {
  return typeof document === 'undefined' ? null : document.getElementById('boot-splash');
}

export function bootSplashHeld() {
  return !!(splash() && document.documentElement.classList.contains('boot-report'));
}

// Fades the splash into whatever has painted under it. Double rAF: React has
// committed a frame first, so there is no white flash between the two.
export function retireBootSplash() {
  if (retired) return;
  retired = true;
  const el = splash();
  if (!el) return;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.style.opacity = '0';
      el.setAttribute('aria-busy', 'false');
      setTimeout(() => el.remove(), 360);
    });
  });
}

// The screen that will take a held splash down says so on mount.
export function claimBootSplash() {
  claimed = true;
}

// New words on the splash while it waits (the database can take a minute to wake).
export function setBootSplashText(heading, line) {
  const el = splash();
  if (!el || retired) return;
  const h = el.querySelector('h1');
  const p = el.querySelector('p');
  if (h && heading) h.textContent = heading;
  if (p && line) p.textContent = line;
}

// main.jsx, after the first render: an unheld splash goes now; a held one waits
// for its screen, within the ceilings.
export function startBootSplash() {
  if (!bootSplashHeld()) { retireBootSplash(); return; }
  setTimeout(() => { if (!claimed) retireBootSplash(); }, CLAIM_MS);
  setTimeout(retireBootSplash, CEILING_MS);
}
